import createIcon from '../../createIcon';

/**
 * @component @name Cached
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgOEwxNSAxMkgxOEMxOCAxNS4zMSAxNS4zMSAxOCAxMiAxOEMxMC45OSAxOCAxMC4wMyAxNy43NSA5LjIgMTcuM0w3Ljc0IDE4Ljc2QzguOTcgMTkuNTQgMTAuNDMgMjAgMTIgMjBDMTYuNDIgMjAgMjAgMTYuNDIgMjAgMTJIMjNMMTkgOFpNNiAxMkM2IDguNjkgOC42OSA2IDEyIDZDMTMuMDEgNiAxMy45NyA2LjI1IDE0LjggNi43TDE2LjI2IDUuMjRDMTUuMDMgNC40NiAxMy41NyA0IDEyIDRDNy41OCA0IDQgNy41OCA0IDEySDFMNSAxNkw5IDEySDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Cached = createIcon('Cached', [
  [
    'path',
    {
      d: 'M19 8L15 12H18C18 15.31 15.31 18 12 18C10.99 18 10.03 17.75 9.2 17.3L7.74 18.76C8.97 19.54 10.43 20 12 20C16.42 20 20 16.42 20 12H23L19 8ZM6 12C6 8.69 8.69 6 12 6C13.01 6 13.97 6.25 14.8 6.7L16.26 5.24C15.03 4.46 13.57 4 12 4C7.58 4 4 7.58 4 12H1L5 16L9 12H6Z',
      key: '1ouh52',
    },
  ],
]);

export default Cached;
